// Croma — play videos only while in view (perf: preload="none" + play-on-view).
// Off-screen videos never download; respects reduced-motion (stays on poster frame).
(function () {
  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vids = document.querySelectorAll('.croma-loc__media video, .croma-video__item video, .croma-story__media video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
